@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'beginntermine'"
    [label]="'Startdatum'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <now-wbsuche-lib-checkbox-facette
        [label]="'Startdatum'"
        [komponentenId]="'beginnterminFacette'"
        [selectItems]="context.items"
        (selected)="updateSelectedIds($event)"
        [facetteLoading]="(loaderService.facettenLoading$ | async)!"
      ></now-wbsuche-lib-checkbox-facette>
    }
  </now-wbsuche-lib-basis-facette>
}
